'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleQuickQuoteSubmit = exports.clearQuotes = exports.fetchQuotes = undefined;
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _constants = require('./constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var fetchQuotes = exports.fetchQuotes = function fetchQuotes(params) {
  return {
    type: _constants.actionTypes.QUOTE,
    payload: _axios2.default.post(_constants.url, params),
    meta: {
      params: params,
      marmalytics: 'quote'
    }
  };
};
var clearQuotes = exports.clearQuotes = function clearQuotes() {
  return {
    type: _constants.actionTypes.CLEAR_QUOTES
  };
};
var handleQuickQuoteSubmit = exports.handleQuickQuoteSubmit = function handleQuickQuoteSubmit(guid) {
  return function (dispatch) {
    return function (formState) {
      if (formState.validAndPristine) {
        dispatch(fetchQuotes(Object.assign({}, formState.values, {
          guid: guid,
          website: 4
        })));
      }
    };
  };
};